
import { defineComponent, PropType } from 'vue'

// @types
import { ExpressZone } from '@/new-services/types/sectors'

export default defineComponent({
    name: 'express-zone-list-item',
    props: {
        item: {
            type: Object as PropType<ExpressZone>,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        isCanUpdate: {
            type: Boolean,
            default: false,
        },
        isCanDelete: {
            type: Boolean,
            default: false,
        }
    },
    emits: ['delete', 'update', 'view'],
    setup(props, { emit }) {
        const onDelete = () => {
            if (props.disabled) return
            emit('delete', { ...props.item })
        }
        
        const onUpdate = () => {
            if (props.disabled) return
            emit('update', { ...props.item })
        }

        const onView = () => {
            if (props.disabled) return
            emit('view', { ...props.item })
        }

        return {
            onDelete,
            onUpdate,
            onView
        }
    }
})
